interface IErrorMessage {
    text? : string;
}

const ErrorMessage = (props: IErrorMessage) => {
    const msg = props.text ? props.text : 'An error has occurred.';

    return (
        <div className="error-box text-sm mt-8" role="alert">
            <p dangerouslySetInnerHTML={{ __html: msg }} />
        </div>
    )
};

export default ErrorMessage;